import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'
import { getToken, isLoggedIn } from '@/utils/auth'
import { storage, STORAGE_KEYS } from '@/utils/storage'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login.vue'),
    meta: { title: '登录', hideInTaskbar: true }
  },
  {
    path: '/',
    component: MainLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/Dashboard.vue'),
        meta: { title: '数据概况', icon: 'DataLine' }
      },
      {
        path: '/auth',
        name: 'Auth',
        meta: { title: '授权管理', icon: 'Key' },
        redirect: '/auth/list',
        children: [
          {
            path: 'list',
            name: 'AuthList',
            component: () => import('@/views/auth/AuthList.vue'),
            meta: { title: '授权列表', icon: 'List' }
          },
          {
            path: 'recycle',
            name: 'RecycleBin',
            component: () => import('@/views/auth/RecycleBin.vue'),
            meta: { title: '回收站', icon: 'Delete' }
          }
        ]
      },
      {
        path: '/app-auth',
        name: 'AppAuth',
        meta: { title: 'APP授权', icon: 'Cellphone' },
        alwaysShow: true, // 添加此属性确保一级菜单显示
        redirect: '/app-auth/list',
        children: [
          {
            path: 'list',
            name: 'AppAuthList',
            component: () => import('@/views/app/AppAuthManage.vue'),
            meta: { title: 'APP授权列表', icon: 'List' }
          }
        ]
      },
      { 
        path: '/service',
        name: 'Service',
        meta: { title: '服务管理', icon: 'Service' },
        redirect: '/service/sms',
        children: [
          {
            path: 'sms',
            name: 'SmsManage',
            component: () => import('@/views/service/sms/index.vue'),
            meta: { title: '短信服务', icon: 'Message' }
          },
          // {
          //   path: 'insurance',
          //   name: 'InsuranceManage',
          //   component: () => import('@/views/service/insurance/index.vue'),
          //   meta: { title: '保险服务', icon: 'Umbrella' }
          // },
          // {
          //   path: 'payment',
          //   name: 'PaymentSetting',
          //   component: () => import('@/views/service/payment/PaymentSetting.vue'),
          //   meta: { title: '支付设置', icon: 'CreditCard' }
          // }
        ]
      },
      {
        path: '/code',
        name: 'Code',
        meta: { title: '代码管理', icon: 'Files' },
        children: [
          {
            path: 'backend',
            name: 'BackendCode',
            component: () => import('@/views/code/VersionManage.vue'),
            meta: { title: '后端版本管理', icon: 'Cpu' }
          },
          {
            path: 'frontend',
            name: 'FrontendCode',
            component: () => import('@/views/code/FrontendCodeManage.vue'),
            meta: { title: '前端代码', icon: 'Monitor' }
          }
        ]
      },
      {
        path: '/provider',
        name: 'Provider',
        meta: { title: '服务商管理', icon: 'Connection' },
        redirect: '/provider/access',
        children: [
          {
            path: 'access',
            name: 'ProviderAccess',
            component: () => import('@/views/provider/ProviderAccess.vue'),
            meta: { title: '服务商接入', icon: 'Link' }
          },
          {
            path: 'resource',
            name: 'ProviderResource',
            component: () => import('@/views/provider/ProviderResource.vue'),
            meta: { title: '服务商资源', icon: 'Coin' }
          },
          {
            path: 'mp-auth',
            name: 'MpAuth',
            component: () => import('@/views/provider/MpAuth.vue'),
            meta: { title: '小程序授权', icon: 'Cellphone' }
          }
        ]
      },
      {
        path: '/settings',
        name: 'Settings',
        meta: { title: '系统设置', icon: 'Setting' },
        children: [
          {
            path: 'site',
            name: 'SiteSettings',
            component: () => import('@/views/settings/SiteSettings.vue'),
            meta: { title: '站点设置', icon: 'Setting' }
          }
        ]
      },
      {
        path: '/redirect',
        name: 'Redirect',
        component: () => import('@/views/redirect/index.vue'),
        meta: { hideInTaskbar: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 获取token
  const token = getToken()
  const isLoginPage = to.path === '/login'
  const loggedIn = isLoggedIn()

  // 打印token状态，方便调试
  console.log('Current route:', to.path)
  console.log('Token status:', token)
  console.log('Is logged in:', loggedIn)

  // 如果是登录页面
  if (isLoginPage) {
    if (loggedIn) {
      // 已登录则跳转到首页
      next('/')
    } else {
      // 未登录则允许访问登录页
      next()
    }
    return
  }

  // 非登录页面
  if (!loggedIn) {
    // 未登录则跳转到登录页
    next('/login')
    return
  }

  // 已登录状态下访问其他页面
  next()
})

// 路由后置守卫 - 设置页面标题
router.afterEach((to) => {
  // 获取站点设置
  const siteSettings = storage.get(STORAGE_KEYS.SITE_SETTINGS)
  const siteName = siteSettings?.siteName || '授权管理系统'
  
  // 设置页面标题
  if (to.meta?.title) {
    document.title = `${to.meta.title} - ${siteName}`
  } else {
    document.title = siteName
  }
})

export default router